
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34332',
  depVersions: {
  "documents-public-ui": "static-1.34332",
  "client-types": "static-1.457",
  "documents-lib": "static-1.34337",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2063",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4938",
  "highcharts": "static-8.102",
  "hs-promise-utils": "static-1.5526",
  "hs-test-utils": "static-1.7945",
  "hub-http": "static-1.6152",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11392",
  "I18n": "static-7.1609",
  "jasmine-immutable": "static-1.2950",
  "jasmine-runner": "static-1.6400",
  "lodash": "static-1.3",
  "quartz": "static-1.6925",
  "react": "static-7.184",
  "react-dlb": "static-1.77",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16592",
  "reporting-data": "static-1.67199",
  "reporting-testing-lib": "static-1.9132",
  "reporting-visualizations": "static-1.59275",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4701",
  "webpack-env": "static-1.54",
  "atom": "static-1.5002",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2426",
  "classnames": "static-2.10",
  "cssUtils": "static-1.777",
  "customer-data-filters-ui": "static-1.39501",
  "customer-data-objects": "static-1.7593",
  "customer-data-property-utils": "static-1.8015",
  "data-fetching-client": "static-1.9606",
  "enviro": "static-4.428",
  "FireAlarmUi": "static-1.4460",
  "flux-actions": "static-1.328",
  "FormsCommonComponents": "static-1.85650",
  "FormUrlGenerator": "static-2.4651",
  "foundations-components": "static-1.7795",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11700",
  "icons": "static-2.642",
  "immutable": "static-2.77",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7090",
  "metrics-js": "static-1.9542",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.388",
  "property-description-translator": "static-1.3779",
  "property-translator": "static-1.5334",
  "quartz-config": "static-1.703",
  "quartz-core": "static-1.6144",
  "quick-fetch": "static-1.3863",
  "raven": "static-3.5829",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.103",
  "react-utils": "static-2.5290",
  "react-virtualized": "static-2.97",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8101",
  "reference-resolvers-lite": "static-1.8023",
  "report-customization-components": "static-1.12919",
  "reporting-enablement": "static-1.22628",
  "reporting-reports": "static-1.66877",
  "reporting-snowflake": "static-1.55817",
  "reporting-ui-components": "static-2.64470",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4576",
  "sales-content-partitioning": "static-1.8868",
  "SalesContentIndexUI": "static-3.9141",
  "sanitize": "static-1.4404",
  "sanitize-text": "static-1.8076",
  "self-service-api": "static-1.10177",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1678",
  "signup-constants": "static-1.18724",
  "signup-ui-lego-core": "static-1.20734",
  "signup-ui-url-generator": "static-2.7967",
  "styled-components": "static-2.88",
  "StyleGuideUI": "static-3.485",
  "superstore": "static-1.4700",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10922",
  "ui-addon-i18n": "static-1.11082",
  "ui-addon-react-router-dom": "static-1.9476",
  "ui-addon-upgrades": "static-9.17887",
  "ui-asset-management-lib": "static-1.10930",
  "ui-images": "static-2.1137",
  "UIComponents": "static-3.8339",
  "usage-tracker": "static-1.7268",
  "usage-tracker-container": "static-1.7258",
  "usage-tracker-core": "static-1.7118",
  "usage-tracker-public": "static-1.7079",
  "viral-links-lib": "static-1.6983",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven-hubspot": "static-1.6136",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3349",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3202",
  "quartz-webpack": "static-1.3149",
  "ai-components-ui-library": "static-1.8764",
  "amplitude-session-replay-browser": "static-1.58",
  "foundations-assets": "static-1.4784",
  "foundations-theming": "static-1.4347",
  "quartz-auth": "static-1.600",
  "ui-business-units-lib": "static-1.8975",
  "usage-tracker-session-replay": "static-1.4954",
  "foundations-theming-base": "static-1.3332",
  "HeadJS": "static-2.739",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3056",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "hs-locale-management": "static-1.30",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4256",
  "csstype": "static-1.50",
  "quartz-head": "static-1.590",
  "frontend-preferences-client": "static-1.7857",
  "graphql": "static-1.80",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3537",
  "persist-promise": "static-1.3641",
  "quartz-i18n": "static-1.600",
  "reporting-client-types": "static-1.2449",
  "foundations-components-legacy": "static-1.820",
  "hs-story-utils": "static-1.9361",
  "react-flip-move": "static-1.68",
  "hub-http-shared-msw-handlers": "static-1.9803",
  "hubspotter-http": "static-1.4598",
  "sassPrefix": "static-1.154",
  "conversations-skeleton-state": "static-1.7182",
  "crm-message-bus": "static-1.42787",
  "customer-data-filters-ui-msw-helpers": "static-1.21936",
  "customer-data-objects-ui-components": "static-1.12953",
  "customer-data-reference-ui-components": "static-1.13087",
  "customer-data-ui-utilities": "static-1.9758",
  "framework-builder-read-service-client": "static-1.3956",
  "framework-data-schema-quick-fetch": "static-1.6712",
  "framework-data-schema-resolvers": "static-1.6807",
  "inbound-db-properties-service-client": "static-1.3788",
  "multi-account-reference-resolvers": "static-1.908",
  "onboarding-tours": "static-1.16467",
  "reporting-datasets-permissions-lib": "static-1.13462",
  "ui-addon-teams": "static-1.21457",
  "apollo-stack-hubspot": "static-3.84",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.68146",
  "customer-data-properties": "static-1.51293",
  "forms-ai-lib": "static-1.4205",
  "forms-utils-lib": "static-1.12450",
  "foundations-components-test-utils": "static-1.5278",
  "react-dnd-compat": "static-1.4551",
  "react-tinymce": "static-1.55040",
  "tinymce-config": "static-2.54166",
  "ui-gdpr-components": "static-1.10279",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4064",
  "floating-ui": "static-1.54",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1612",
  "ui-fonts": "static-1.654",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.825",
  "mobile-manifest-mixins": "static-1.513",
  "module-federation": "static-1.21",
  "quartz-routing": "static-1.355",
  "quartz-test": "static-1.600",
  "quartz-tracking": "static-1.304",
  "batch-promise": "static-1.1484",
  "external-options-client-types": "static-1.4105",
  "react-colorpicker": "static-2.10141",
  "copilot-toolkit": "static-1.10938",
  "data-quality-ui-library": "static-1.12692",
  "html-to-image": "static-1.52",
  "onboarding-scopes": "static-1.6396",
  "reporting-action-components": "static-1.41105",
  "reporting-filters": "static-1.134",
  "reporting-insights-lib": "static-1.1513",
  "reporting-plugins": "static-1.10180",
  "ui-addon-draggable-compat": "static-2.4186",
  "ui-addon-opt": "static-4.8312",
  "zustand": "static-1.72",
  "growth-payments-core": "static-1.25153",
  "hubspot-apollo-client": "static-1.4809",
  "chirp-fetch": "static-1.1814",
  "sales-templates-service-types-lib": "static-1.4114",
  "merchandise-lib": "static-1.262",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5759",
  "salesImages": "static-1.523",
  "ts-schema": "static-1.4024",
  "nested-table": "static-1.158",
  "timezone-utils": "static-2.5175",
  "bender-build-tools": "static-1.3093",
  "chatspot-core": "static-1.20957",
  "bend-plugin-foundations-theming": "static-1.2830",
  "stylex": "static-1.31",
  "hubspotter-http-shared-msw-handlers": "static-1.9801",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3743",
  "crm-pipelines-api-client-types": "static-1.4089",
  "multi-currency-client-types": "static-1.3638",
  "getting-started-shared-tasks": "static-1.18295",
  "growth-data-modal": "static-1.5316",
  "growth-onboarding-confetti": "static-1.3001",
  "growth-onboarding-next-action-utils": "static-1.1702",
  "navigation-components": "static-1.17783",
  "onboarding-tours-client": "static-1.4681",
  "onboarding-tours-utils": "static-1.533",
  "ui-shepherd-react": "static-3.10080",
  "ui-shepherd-tracker": "static-1.7461",
  "ui-universal-auth": "static-1.8887",
  "user-context": "static-1.5032",
  "cms-field-types": "static-1.4741",
  "content-icons-ui": "static-1.2210",
  "integrations-lib": "static-1.15884",
  "calling-global-api": "static-1.64246",
  "calling-internal-common": "static-1.31234",
  "calling-lifecycle-internal": "static-1.65628",
  "calling-lifecycle-messages": "static-1.57922",
  "commerce-products-lib": "static-1.9259",
  "crm-links": "static-1.6211",
  "customer-data-properties-shared-msw-handlers": "static-1.9130",
  "file-manager-components": "static-1.23409",
  "google-libphonenumber": "static-1.36",
  "hs-resources": "static-1.72",
  "inbounddb-objects-service-types": "static-1.4170",
  "meetings-icalendar-utils-lib": "static-1.562",
  "object-builder-ui-client": "static-1.48498",
  "pipeline-validation-client-types": "static-1.3912",
  "property-value-citations": "static-1.1907",
  "pulse": "static-1.483",
  "smart-property-lib": "static-1.6585",
  "tiered-pricing": "static-1.1060",
  "ui-addon-iframeable": "static-1.8983",
  "final-form": "static-1.68",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19710",
  "tinymce-themes": "static-1.56136",
  "data-token-picker": "static-1.16281",
  "hub-http-contrib": "static-1.2973",
  "interframe": "static-3.4694",
  "tinymce-data": "static-1.40251",
  "tinymce-plugins": "static-1.57280",
  "ui-addon-sales-email": "static-1.5143",
  "magpie-lib": "static-1.5516",
  "magpie-types": "static-1.4976",
  "simple-logging-lib": "static-1.2982",
  "content-assistance-lib": "static-1.7645",
  "dashboard-lib": "static-1.81244",
  "ExportDialog": "static-6.10323",
  "hubspot-prosemirror": "static-1.18027",
  "hubspot-prosemirror-plugins": "static-1.18019",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8628",
  "campaign-roi-lib": "static-1.8783",
  "feedback-loader": "static-1.29171",
  "apollo-link-hub-http": "static-2.4582",
  "hubspot-apollo-cache": "static-1.268",
  "purchase-motions-api": "static-1.5762",
  "trials-service-types": "static-1.3833",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.105",
  "markdown-it": "static-1.6",
  "onboarding-data-sync-lib": "static-1.1840",
  "growth-onboarding-next-action-components": "static-1.1730",
  "user-context-client": "static-1.4543",
  "idb-keyval": "static-1.42",
  "nest": "static-1.155",
  "reactive-lib": "static-1.654",
  "unified-auth-core-lib": "static-1.682",
  "getting-started-shared-tasks-store": "static-1.17413",
  "integrations-error-boundary-lib": "static-1.13299",
  "integrations-tracking-lib": "static-1.5528",
  "native-integrations-shared-strings": "static-1.7717",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10305",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.401",
  "calling-error-reporting": "static-1.31240",
  "shared-worker-versioning": "static-1.10969",
  "calling-usage-tracker": "static-1.6472",
  "voice-sms-access-library": "static-1.706",
  "customer-data-tracking": "static-1.6816",
  "commerce-permissions": "static-1.698",
  "products-iframe-lib": "static-1.7726",
  "products-ui-components-shared-msw-handlers": "static-1.10185",
  "location-customization-utils-lib": "static-1.9024",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4084",
  "video-components-external": "static-1.11039",
  "video-data-lib": "static-1.34697",
  "directed-graph": "static-1.869",
  "event-emitter": "static-1.879",
  "fast-json-patch": "static-1.61",
  "data-agent-kit": "static-1.82",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9886",
  "fsm": "static-1.3666",
  "policy-lib": "static-1.6712",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9949",
  "navigation-messaging": "static-1.7110",
  "FileManagerLib": "static-1.39049",
  "NamespacedHubStyle": "static-2.9011",
  "FileManagerCore": "static-1.38908",
  "codemirror": "static-5.93",
  "layout-dnd-components": "static-1.12311",
  "layout-dnd-utils": "static-1.11286",
  "react-codemirror": "static-1.10555",
  "ui-addon-emoji-picker": "static-1.9819",
  "ui-brand-identity-lib": "static-1.14937",
  "ui-addon-video-player": "static-1.8628",
  "ui-coaching-tips": "static-1.28342",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8479",
  "payment-link-components": "static-1.23329",
  "EmailSignatureEditor": "static-1.24222",
  "InboxConnectUtils": "static-4.14609",
  "universal-page-editor-lib": "static-1.2940",
  "google-sheets-integration-lib": "static-1.26",
  "microsoft-drive-integration-lib": "static-1.117",
  "calling-orchestration-schema": "static-1.35483",
  "sales-views-client-types": "static-1.4194",
  "crm-record-cards-service-types": "static-1.3557",
  "content-media-composition-data-lib": "static-1.12016",
  "content-media-compositions": "static-2.16023",
  "media-bridge-lib": "static-1.18804",
  "trellis-story-utils": "static-1.4449",
  "storybook-react": "static-1.31",
  "audio-components": "static-1.5808",
  "FileManagerImages": "static-1.36560",
  "video-components": "static-1.13042",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4464",
  "video-embed": "static-1.35531",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68221",
  "layout-data-lib": "static-1.9611",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6514",
  "commerce-tours-lib": "static-1.5966",
  "growth-onboarding-reliability": "static-1.5015",
  "sales-checkout-service-client": "static-1.3571",
  "draft-convert": "static-2.71",
  "draft-extend": "static-3.73",
  "draft-js": "static-5.76",
  "draft-plugins": "static-2.21549",
  "sales-email-signature-service-client": "static-1.3774",
  "social-insights-client-types": "static-1.21872",
  "outpost": "static-1.4121",
  "advanced-menus-core": "static-1.15019",
  "advanced-menus-lib": "static-1.11974",
  "ui-memberships-settings-lib": "static-1.33846",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15018",
  "simple-menus-lib": "static-1.16535"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34332",
  "client-types": "/client-types/static-1.457",
  "documents-lib": "/documents-lib/static-1.34337",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2063",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4938",
  "highcharts": "/highcharts/static-8.102",
  "hs-promise-utils": "/hs-promise-utils/static-1.5526",
  "hs-test-utils": "/hs-test-utils/static-1.7945",
  "hub-http": "/hub-http/static-1.6152",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11392",
  "I18n": "/I18n/static-7.1609",
  "jasmine-immutable": "/jasmine-immutable/static-1.2950",
  "jasmine-runner": "/jasmine-runner/static-1.6400",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6925",
  "react": "/react/static-7.184",
  "react-dlb": "/react-dlb/static-1.77",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16592",
  "reporting-data": "/reporting-data/static-1.67199",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9132",
  "reporting-visualizations": "/reporting-visualizations/static-1.59275",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4701",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.5002",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2426",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.777",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39501",
  "customer-data-objects": "/customer-data-objects/static-1.7593",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8015",
  "data-fetching-client": "/data-fetching-client/static-1.9606",
  "enviro": "/enviro/static-4.428",
  "FireAlarmUi": "/FireAlarmUi/static-1.4460",
  "flux-actions": "/flux-actions/static-1.328",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85650",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4651",
  "foundations-components": "/foundations-components/static-1.7795",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11700",
  "icons": "/icons/static-2.642",
  "immutable": "/immutable/static-2.77",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7090",
  "metrics-js": "/metrics-js/static-1.9542",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "property-description-translator": "/property-description-translator/static-1.3779",
  "property-translator": "/property-translator/static-1.5334",
  "quartz-config": "/quartz-config/static-1.703",
  "quartz-core": "/quartz-core/static-1.6144",
  "quick-fetch": "/quick-fetch/static-1.3863",
  "raven": "/raven/static-3.5829",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.103",
  "react-utils": "/react-utils/static-2.5290",
  "react-virtualized": "/react-virtualized/static-2.97",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8101",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8023",
  "report-customization-components": "/report-customization-components/static-1.12919",
  "reporting-enablement": "/reporting-enablement/static-1.22628",
  "reporting-reports": "/reporting-reports/static-1.66877",
  "reporting-snowflake": "/reporting-snowflake/static-1.55817",
  "reporting-ui-components": "/reporting-ui-components/static-2.64470",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4576",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8868",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9141",
  "sanitize": "/sanitize/static-1.4404",
  "sanitize-text": "/sanitize-text/static-1.8076",
  "self-service-api": "/self-service-api/static-1.10177",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1678",
  "signup-constants": "/signup-constants/static-1.18724",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20734",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7967",
  "styled-components": "/styled-components/static-2.88",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "superstore": "/superstore/static-1.4700",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10922",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11082",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9476",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17887",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10930",
  "ui-images": "/ui-images/static-2.1137",
  "UIComponents": "/UIComponents/static-3.8339",
  "usage-tracker": "/usage-tracker/static-1.7268",
  "usage-tracker-container": "/usage-tracker-container/static-1.7258",
  "usage-tracker-core": "/usage-tracker-core/static-1.7118",
  "usage-tracker-public": "/usage-tracker-public/static-1.7079",
  "viral-links-lib": "/viral-links-lib/static-1.6983",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3349",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3202",
  "quartz-webpack": "/quartz-webpack/static-1.3149",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8764",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "foundations-assets": "/foundations-assets/static-1.4784",
  "foundations-theming": "/foundations-theming/static-1.4347",
  "quartz-auth": "/quartz-auth/static-1.600",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8975",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4954",
  "foundations-theming-base": "/foundations-theming-base/static-1.3332",
  "HeadJS": "/HeadJS/static-2.739",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3056",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "hs-locale-management": "/hs-locale-management/static-1.30",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4256",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.590",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7857",
  "graphql": "/graphql/static-1.80",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3537",
  "persist-promise": "/persist-promise/static-1.3641",
  "quartz-i18n": "/quartz-i18n/static-1.600",
  "reporting-client-types": "/reporting-client-types/static-1.2449",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.820",
  "hs-story-utils": "/hs-story-utils/static-1.9361",
  "react-flip-move": "/react-flip-move/static-1.68",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9803",
  "hubspotter-http": "/hubspotter-http/static-1.4598",
  "sassPrefix": "/sassPrefix/static-1.154",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7182",
  "crm-message-bus": "/crm-message-bus/static-1.42787",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21936",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12953",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13087",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9758",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3956",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6712",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6807",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3788",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.908",
  "onboarding-tours": "/onboarding-tours/static-1.16467",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13462",
  "ui-addon-teams": "/ui-addon-teams/static-1.21457",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.68146",
  "customer-data-properties": "/customer-data-properties/static-1.51293",
  "forms-ai-lib": "/forms-ai-lib/static-1.4205",
  "forms-utils-lib": "/forms-utils-lib/static-1.12450",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5278",
  "react-dnd-compat": "/react-dnd-compat/static-1.4551",
  "react-tinymce": "/react-tinymce/static-1.55040",
  "tinymce-config": "/tinymce-config/static-2.54166",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10279",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4064",
  "floating-ui": "/floating-ui/static-1.54",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1612",
  "ui-fonts": "/ui-fonts/static-1.654",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.825",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.513",
  "module-federation": "/module-federation/static-1.21",
  "quartz-routing": "/quartz-routing/static-1.355",
  "quartz-test": "/quartz-test/static-1.600",
  "quartz-tracking": "/quartz-tracking/static-1.304",
  "batch-promise": "/batch-promise/static-1.1484",
  "external-options-client-types": "/external-options-client-types/static-1.4105",
  "react-colorpicker": "/react-colorpicker/static-2.10141",
  "copilot-toolkit": "/copilot-toolkit/static-1.10938",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12692",
  "html-to-image": "/html-to-image/static-1.52",
  "onboarding-scopes": "/onboarding-scopes/static-1.6396",
  "reporting-action-components": "/reporting-action-components/static-1.41105",
  "reporting-filters": "/reporting-filters/static-1.134",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1513",
  "reporting-plugins": "/reporting-plugins/static-1.10180",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4186",
  "ui-addon-opt": "/ui-addon-opt/static-4.8312",
  "zustand": "/zustand/static-1.72",
  "growth-payments-core": "/growth-payments-core/static-1.25153",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4809",
  "chirp-fetch": "/chirp-fetch/static-1.1814",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4114",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5759",
  "salesImages": "/salesImages/static-1.523",
  "ts-schema": "/ts-schema/static-1.4024",
  "nested-table": "/nested-table/static-1.158",
  "timezone-utils": "/timezone-utils/static-2.5175",
  "bender-build-tools": "/bender-build-tools/static-1.3093",
  "chatspot-core": "/chatspot-core/static-1.20957",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2830",
  "stylex": "/stylex/static-1.31",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9801",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3743",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4089",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3638",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18295",
  "growth-data-modal": "/growth-data-modal/static-1.5316",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3001",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1702",
  "navigation-components": "/navigation-components/static-1.17783",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4681",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.533",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10080",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7461",
  "ui-universal-auth": "/ui-universal-auth/static-1.8887",
  "user-context": "/user-context/static-1.5032",
  "cms-field-types": "/cms-field-types/static-1.4741",
  "content-icons-ui": "/content-icons-ui/static-1.2210",
  "integrations-lib": "/integrations-lib/static-1.15884",
  "calling-global-api": "/calling-global-api/static-1.64246",
  "calling-internal-common": "/calling-internal-common/static-1.31234",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65628",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57922",
  "commerce-products-lib": "/commerce-products-lib/static-1.9259",
  "crm-links": "/crm-links/static-1.6211",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9130",
  "file-manager-components": "/file-manager-components/static-1.23409",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "hs-resources": "/hs-resources/static-1.72",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4170",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.562",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48498",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3912",
  "property-value-citations": "/property-value-citations/static-1.1907",
  "pulse": "/pulse/static-1.483",
  "smart-property-lib": "/smart-property-lib/static-1.6585",
  "tiered-pricing": "/tiered-pricing/static-1.1060",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8983",
  "final-form": "/final-form/static-1.68",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19710",
  "tinymce-themes": "/tinymce-themes/static-1.56136",
  "data-token-picker": "/data-token-picker/static-1.16281",
  "hub-http-contrib": "/hub-http-contrib/static-1.2973",
  "interframe": "/interframe/static-3.4694",
  "tinymce-data": "/tinymce-data/static-1.40251",
  "tinymce-plugins": "/tinymce-plugins/static-1.57280",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5143",
  "magpie-lib": "/magpie-lib/static-1.5516",
  "magpie-types": "/magpie-types/static-1.4976",
  "simple-logging-lib": "/simple-logging-lib/static-1.2982",
  "content-assistance-lib": "/content-assistance-lib/static-1.7645",
  "dashboard-lib": "/dashboard-lib/static-1.81244",
  "ExportDialog": "/ExportDialog/static-6.10323",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18027",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18019",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8628",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8783",
  "feedback-loader": "/feedback-loader/static-1.29171",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4582",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.268",
  "purchase-motions-api": "/purchase-motions-api/static-1.5762",
  "trials-service-types": "/trials-service-types/static-1.3833",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.105",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1840",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1730",
  "user-context-client": "/user-context-client/static-1.4543",
  "idb-keyval": "/idb-keyval/static-1.42",
  "nest": "/nest/static-1.155",
  "reactive-lib": "/reactive-lib/static-1.654",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.682",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17413",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13299",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5528",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7717",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10305",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.401",
  "calling-error-reporting": "/calling-error-reporting/static-1.31240",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10969",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6472",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.706",
  "customer-data-tracking": "/customer-data-tracking/static-1.6816",
  "commerce-permissions": "/commerce-permissions/static-1.698",
  "products-iframe-lib": "/products-iframe-lib/static-1.7726",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10185",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9024",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4084",
  "video-components-external": "/video-components-external/static-1.11039",
  "video-data-lib": "/video-data-lib/static-1.34697",
  "directed-graph": "/directed-graph/static-1.869",
  "event-emitter": "/event-emitter/static-1.879",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "data-agent-kit": "/data-agent-kit/static-1.82",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9886",
  "fsm": "/fsm/static-1.3666",
  "policy-lib": "/policy-lib/static-1.6712",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9949",
  "navigation-messaging": "/navigation-messaging/static-1.7110",
  "FileManagerLib": "/FileManagerLib/static-1.39049",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9011",
  "FileManagerCore": "/FileManagerCore/static-1.38908",
  "codemirror": "/codemirror/static-5.93",
  "layout-dnd-components": "/layout-dnd-components/static-1.12311",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11286",
  "react-codemirror": "/react-codemirror/static-1.10555",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9819",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14937",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8628",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28342",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8479",
  "payment-link-components": "/payment-link-components/static-1.23329",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24222",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14609",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2940",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.26",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.117",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35483",
  "sales-views-client-types": "/sales-views-client-types/static-1.4194",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3557",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12016",
  "content-media-compositions": "/content-media-compositions/static-2.16023",
  "media-bridge-lib": "/media-bridge-lib/static-1.18804",
  "trellis-story-utils": "/trellis-story-utils/static-1.4449",
  "storybook-react": "/storybook-react/static-1.31",
  "audio-components": "/audio-components/static-1.5808",
  "FileManagerImages": "/FileManagerImages/static-1.36560",
  "video-components": "/video-components/static-1.13042",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4464",
  "video-embed": "/video-embed/static-1.35531",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68221",
  "layout-data-lib": "/layout-data-lib/static-1.9611",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6514",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5966",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5015",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3571",
  "draft-convert": "/draft-convert/static-2.71",
  "draft-extend": "/draft-extend/static-3.73",
  "draft-js": "/draft-js/static-5.76",
  "draft-plugins": "/draft-plugins/static-2.21549",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3774",
  "social-insights-client-types": "/social-insights-client-types/static-1.21872",
  "outpost": "/outpost/static-1.4121",
  "advanced-menus-core": "/advanced-menus-core/static-1.15019",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11974",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33846",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15018",
  "simple-menus-lib": "/simple-menus-lib/static-1.16535"
}
};
